// src/store/formReset/reducer.js
import { RESET_FORM_FIELDS} from "../formReset/types";

const initialState = {
  shouldReset: false,
};

const formResetReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FORM_FIELDS:
      return {
        ...state,
        shouldReset: action.payload !== false,
      };
    default:
      return state;
  }
};

export default formResetReducer;